import { render, staticRenderFns } from "./BlogPostDetails.vue?vue&type=template&id=a748c664&scoped=true&"
import script from "./BlogPostDetails.vue?vue&type=script&lang=ts&"
export * from "./BlogPostDetails.vue?vue&type=script&lang=ts&"
import style0 from "./BlogPostDetails.vue?vue&type=style&index=0&id=a748c664&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a748c664",
  null
  
)

export default component.exports